import Vue from 'vue'
import VueRouter from 'vue-router'
import VueI18n from 'vue-i18n'

import Main from './main.vue'
import Logo from './logo.vue'
import API from './api.vue'
import About from './about.vue'
import _404 from './404.vue'
import Nav from './nav.vue'

import './style.css'
Vue.use(VueRouter);
Vue.use(VueI18n);

const routes = [
    {title: 'qwq', path: '/', component: Main},
    {title: 'owo', path: '/api', component: API},
    {title: 'pwp', path: '/about', component: About},
    {path: '/404', component: _404},
];

const router = new VueRouter({
    routes
});

const i18n = new VueI18n({
    locale: navigator.language.split('-')[0],
    fallbackLocale: 'en',
    messages: {
        en: {
        },
    }
});

new Vue({
    router,
    i18n,
    data: {
        routes: routes,
    },
    el: '#app',
    components: {
        'logo': Logo,
        'nav-section': Nav,
    }
});



// WEBPACK FOOTER //
// ./src/main.js